/**
 * Warning validators for form fields
 * These functions check for conditions that should show warnings but not block form submission
 */

/**
 * Validates name input for potential mismatches with patient's insurance/ID
 * Shows warning for multiple names, hyphens, or single letters (initials)
 * @param {string} value - The input value to validate
 * @param {string} message - Custom warning message
 * @returns {Object} - { shouldWarn: boolean, message: string }
 */
export const warnOnHyphenSpaceOrInitials = (value, message) => {
  if (!value) {
    return { shouldWarn: false, message: "" };
  }

  const trimmedValue = value.trim();
  const words = trimmedValue.split(/\s+/);
  const hasHyphen = trimmedValue.includes("-");
  const hasSingleLetter = /\b[a-zA-Z]\b/.test(trimmedValue);

  if (words.length === 1 && !hasHyphen && !hasSingleLetter) {
    return { shouldWarn: false, message: "" };
  }

  return {
    shouldWarn: true,
    message: message
  };
};
